<template>
  <ul class="nav">
    <li>
    </li>
  </ul>
</template>
<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'TOptions',
  methods: {
    helpRedirect() {
      const website = process.env.VUE_APP_WEBSITE_URL;
      return `${website}/help`;
    },
  },
});
</script>

<style lang="scss" scoped>
ul.nav {
  @apply md:space-x-8;
  li:not(:first-child) {
    border-top: 1px solid rgba(18, 20, 23, 0.88);
    @include medium {
      border-top: 0px;
    }
  }
  li {
    @apply py-2;
    a {
      @apply py-2 block text-center text-token-neutral-on-fill-highest-day;
    }
  }
}
</style>
